/**
 * ADRE Online Licensing System Web API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * Submit required information request type
 */
export class SubmitRequiredUserInformationRequestModel { 
    /**
     * ADRE Session ID
     */
    SessionID: number;
    /**
     * If submitting password information set to True
     */
    PasswordInformationSpecified: boolean;
    /**
     * User password
     */
    Password?: string = "";
    /**
     * User pasword hint question
     */
    PasswordHintQuestionID?: number;
    /**
     * User password hint answer
     */
    PasswordHintAnswer?: string;
    /**
     * If submitting email address set to True
     */
    EmailAddressSpecified: boolean;
    /**
     * User email address
     */
    EmailAddress?: string = "";
    /**
     * If submitting accepting terms and conditions set to True
     */
    TermsAcceptedSpecified: boolean;
    /**
     * Terms and contditions accepted
     */
    TermsAccepted?: boolean;
}



// WEBPACK FOOTER //
// ./src/app/model/submitRequiredUserInformationRequestModel.ts